import { Div, Collection, Snack } from "@tblabs/truffle";
import { AdminStepPrinter } from "../../Components/AdminStepPrinter";
import { Center } from "../../Components/Utils/Center";
import { SmallHeader } from "../../Components/Utils/SmallHeader";
import { Order } from "../../Models/Order";
import { AuthService } from "../../Services/Auth/AuthService";
import { OrdersManager } from "../../Services/OrdersManager";
import { Router } from "../../Services/Router";
import { StepsMarker } from "../../Services/StepsMarker";
import { StepsOrganizer } from "../Admin/OrdersView/Views/ToDo/StepsOrganizer";
import { AgentsProvider } from "../../Services/AgentsProvider";
import { FatalError } from "../../Components/FatalError";


export class AgentToDoView extends Div
{
    constructor(
        _router: Router,
        _manager: OrdersManager,
        _auth: AuthService,
        _agents: AgentsProvider,
        orders: Collection<Order>,
        filterByAgentId: string)
    {
        super();

        if (!_agents.Get(filterByAgentId))
        {
            this.Append(new FatalError(`Agent o Id "${filterByAgentId}" nie istnieje`))
            return;
        }

        const stepsOrganizer = new StepsOrganizer();

        orders.Items.forEach(order =>
        {
            order.OnChange(async () =>
            {
                await _manager.Update(order);
                new Snack(`Zamówienie #${order.ShortId} zaktualizowane`);
            });

            const steps = order.Steps.Items;
            const markedSteps = StepsMarker.Mark(steps);

            markedSteps.forEach(step =>
            {
                const assignedAgentId = step.Step.Data.AssignedAgentId.value;
                const aId = filterByAgentId ?? _auth.UserInfo?.User?.Id;

                if (assignedAgentId === aId)
                {
                    stepsOrganizer.PutToBag(step);
                }
            })
        });

        stepsOrganizer.Bags
            .map(bag =>
                this.Append(
                    new SmallHeader(bag.Title + ` (${bag.Size})`),
                    new Div("blocks-container").Append(
                        ...bag.Items.map(step => new AdminStepPrinter(_router, _agents, step))
                    ),
                    bag.Size == 0 && new Center(`Brak zadań ${bag.Title.toLowerCase()}`).Italic().Color("#aaa")
                )
            );
    }
}
